export function LogoMark({ size = 28 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
      <rect width="32" height="32" rx="8" fill="var(--fg)" />
      <rect x="7" y="9" width="18" height="2.6" rx="1.3" fill="var(--bg)" />
      <rect x="7" y="14.8" width="11" height="1.6" rx="0.8" fill="var(--accent)" />
      <rect x="7" y="20.4" width="14" height="2.6" rx="1.3" fill="var(--bg)" />
    </svg>
  );
}

export function Brand({ subtitle }: { subtitle?: string }) {
  return (
    <a href="/" className="flex min-h-11 items-center gap-3" aria-label="Interligne home">
      <LogoMark />
      <span className="flex flex-col leading-none">
        <span className="font-display text-2xl italic tracking-tight">Interligne</span>
        {subtitle ? <span className="mt-1 text-[11px] tracking-[0.18em] text-muted uppercase">{subtitle}</span> : null}
      </span>
    </a>
  );
}
